"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearBaseProperties = clearBaseProperties;
exports.getBaseProperties = getBaseProperties;
exports.setBaseProperties = setBaseProperties;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * Base Properties Registry
 *
 * This module provides a way to store and retrieve base properties
 * for use in non-React code (like Redux middleware, socket handlers, etc.)
 *
 * The base properties are set by the MetricsProvider and include:
 * - appVersion, product, businessUnit, component
 * - persona, accountMappingId, environmentName
 * - userId, teamId, broadcastId, etc.
 */

var baseProperties = {};

/**
 * Set the base properties that will be included with all tracked events
 * @param {Object} props - Base properties object
 */
function setBaseProperties(props) {
  baseProperties = _objectSpread({}, props);
}

/**
 * Get the current base properties
 * @returns {Object} Base properties object
 */
function getBaseProperties() {
  return _objectSpread({}, baseProperties);
}

/**
 * Clear all base properties (useful for testing)
 */
function clearBaseProperties() {
  baseProperties = {};
}